<template>
	<div class="classCompany">
		<div class="classCompany_wrap">
			<div class="classCompanyTitle">
				<p>班级公司管理</p>
				<el-button plain size="mini" @click="createdClass">创建班级</el-button>
			</div>
			<div class="classCompanyContent">
				<div class="cardAll">
					<div v-for="(o, index) in classCompany" :key="index" class="box-card" style=" ">
			
			
						<img :src="o.companyLogo" style="height: 120px; width: 215px; border-radius: 8px" />
						<div style="margin-left: 20px;flex:1">
							<h3 :title="o.companyName" style="
			            font-size: 16px;
			            overflow: hidden;
			            text-overflow: ellipsis;
			            white-space: nowrap;
			            line-height: 25px;
			          ">
								{{ o.companyName }}
							</h3>
							<div style="
			            margin-top: 10px;
			            height: 38px;
			                background: rgb(252 252 252);
			            padding: 5px 5px;
			          ">
								<p :title="o.companyContext" style="
			              font-size: 12px;
			              width: 100%;
			              overflow: hidden;
			              display: -webkit-box;
			              -webkit-box-orient: vertical;
			              -webkit-line-clamp: 4;
			              text-overflow: ellipsis;
			            ">
									{{ o.companyContext }}
								</p>
							</div>
							<div style="
			            display: flex;
			            justify-content: space-between;
			            margin-top: 20px;
			          ">
								<span style="display: flex">
									<div style="position: relative; margin-right: 30px">
										<span style="font-size: 12px; color: #0e56ad" @click="open_dialog(o)">
											公司业务管理
										</span>
										<span class="gsywgl"></span>
									</div>
									<div style="position: relative; margin-right: 30px">
										<span style="font-size: 12px; color: #0e56ad" @click="del(o)">
											删除公司数据
										</span>
										<span class="del"></span>
									</div>
			
								</span>
								<div style="display:flex">
									<div style="position: relative;margin-right:30px">
										<span style="font-size: 12px; color: #0e56ad" @click="employeeInformationTable(o)">
											人事管理
										</span>
										<span class="rsgl"></span>
									</div>
									<div style="position: relative">
										<span style="
			                font-size: 12px;
			                color: #0e56ad;
			                display: flex;
			                align-items: center;
			                margin-top: 3px;
			              " @click="enterOffice(o)">进入办公区 <i class="el-icon-right"></i></span>
										<span class="jrbgq"></span>
									</div>
								</div>
			
							</div>
						</div>
			
					</div>
				</div>
				<!-- 班级公司管理分页 -->
				<div class="selectePages">
					<el-pagination @size-change="classCompanySizeChange" @current-change="classCompanyCurrentChange"
						:current-page.sync="totalObj.currentPage" background :page-sizes="[10, 20, 50, 100]"
						:page-size="totalObj.pageSize" layout="sizes, prev, pager, next" :total="totalObj.total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog destroy-on-close class="dialog" width="500px" style="border-radius: 25px"
			:visible.sync="dialogVisible" title="创建公司" center>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="公司名称" prop="companyName">
					<el-input style="width: 290px" v-model="ruleForm.companyName"></el-input>
				</el-form-item>
				<el-form-item label="公司简介" prop="companyContext">
					<el-input style="width: 290px" type="textarea" v-model="ruleForm.companyContext"></el-input>
				</el-form-item>

				<el-form-item label="项目引入" prop="subjectId">
					<el-select multiple style="width: 290px" v-model="ruleForm.subjectId" placeholder="请选择项目">
						<el-option v-for="item in subjectList" :key="item.id" :label="item.projectName"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item class="upload_custom" label="上传图片" prop="companyLogo">
					<el-upload :limit="1" :file-list="flieList" list-type="picture-card" ref="addUpload"
						:action="materialForm.url" :headers="headers" :on-success="handleAvatarSuccess">
						<i class="el-input__icon el-icon-plus"></i>
					</el-upload>
				</el-form-item>
				<el-form-item>
					<div style="display: flex; justify-content: center">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="handleSave('ruleForm')">确 定</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import bus from "../../../bus/bus";
	import * as api from "../../../api/marketingProjectManagement"; // 内容展示
	export default {
		data() {
			return {
				flieList: [],
				WhetherHave: false,
				professional: sessionStorage.getItem("professional"),
				classCompany: [],
				subjectList: [],
				totalObj: {
					pageSize: 10,
					currentPage: 1,
					total: 0,
				},
				ruleForm: {
					companyName: "",
					companyContext: "",
					companyLogo: "",
					subjectId: "",
				},
				//图片上传
				materialForm: {
					url: `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`,
					data: {
						savepath: "cjdd/resourse/",
					},
					fileName: "",
					id: "",
				},
				dialogVisible: false,
				//输入框验证规则
				rules: {
					companyName: [{
						required: true,
						message: "请输入公司名称",
						trigger: "blur"
					}, ],
					companyContext: [{
						required: true,
						message: "请输入公司简介",
						trigger: "blur"
					}, ],
					subjectId: [{
						required: true,
						message: "请选择项目",
						trigger: "change"
					}, ],
				},
				mgyObj: null,
			};
		},
		computed: {
			headers() {
				return {
					Authorization: "bearer " + localStorage.getItem("Authorization"),
				};
			},
		},
		created() {
			this.classCompanyInit();
		},
		methods: {
			enterOffice(val) {
				console.log(val)
				api.judgeTeam(val.id).then(res => {
					if (res.code == 0) {
						if (res.data && res.data.status == 2) {
							this.$emit("jumpMgy",val)
						}
					} else {
						this.$messageError(res.msg)
					}
				})
			},
			//查询班级公司列表
			classCompanyInit() {
				this.params = {
					professionalId: this.professional,
					pageSize: this.totalObj.pageSize,
					pageNo: this.totalObj.currentPage,
				};
				api.CompanyList(this.params).then((res) => {
					if (res.code == 0) {
						if (res.data.records.length < 1) {
							this.WhetherHave = true;
						} else {
							this.WhetherHave == false;
						}
						this.classCompany = res.data.records;
						this.totalObj.total = res.data.total;
					}
				});
			},

			//项目引用
			projectList() {
				this.params = {
					professionalId: this.professional,
					status: 1,
				};
				api.projectList(this.params).then((res) => {
					if (res.code == 0) {
						this.subjectList = res.data.list;
					}
				});
			},

			//创建班级
			createdClass() {
				this.flieList = [];
				this.dialogVisible = true;
				this.ruleForm.companyContext = "";
				// this.ruleForm.companyLogo = "";
				this.ruleForm.companyName = "";
				this.ruleForm.subjectId = [];
				this.id = "";
				this.projectList();
				// if(this.$refs.addUpload !== undefined){
				//   this.$refs.addUpload.clearFiles()
				// }
			},
			//上传成功
			handleAvatarSuccess(res, file) {
				if (res.code == 0) {
					this.ruleForm.companyLogo = res.data.newAttaUrl;
				} else {
					let fileId = file.uid;
					this.showUploadFileList.forEach((item) => {
						if (item.uid == fileId) {
							item.state = "上传失败";
						}
					});
					this.$message.error("格式不支持上传");
				}
			},
			//保存
			handleSave(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.companyLogo == "") {
							this.$message({
								message: "请上传图片",
								type: "warning",
							});
							return;
						}
						this.dialogVisible = false;
						let params = {
							id: this.id,
							companyContext: this.ruleForm.companyContext,
							companyLogo: this.ruleForm.companyLogo,
							companyName: this.ruleForm.companyName,
							professionalId: this.professional,
							projectIds: this.ruleForm.subjectId,
						};
						if (
							this.ruleForm.companyContext != "" &&
							this.ruleForm.companyLogo != "" &&
							this.ruleForm.companyName != "" &&
							this.ruleForm.subjectId != ""
						) {
							if (this.id == "") {
								api.SaveCompany(params).then((res) => {
									if (res.code == 0) {
										this.classCompanyInit();

										this.$message({
											message: "新增成功",
											type: "success",
										});
									}
								});
							} else {
								api.updateCompany(params).then((res) => {
									if (res.code == 0) {
										this.classCompanyInit();
										this.$message({
											message: "修改成功",
											type: "success",
										});

										// this.answerList = res.data
									}
								});
							}
						} else {
							console.log(222);
							this.dialogVisible = true;
							this.$message({
								message: "保存失败",
								type: "warning",
							});
						}
					} else {
						return false;
					}
				});
			},
			//删除
			del(a) {
				this.$confirm("此操作将永久删除该公司, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.id = a.id;
						let params = {
							id: this.id,
						};
						api.deleteCompany(params).then((res) => {
							if (res.code == 0) {
								this.classCompanyInit();
								// this.answerList = res.data
							}
						});
						this.$message({
							type: "success",
							message: "删除成功!",
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			//编辑时带参数
			open_dialog(a) {
				console.log(a, "a.companyLogo");
				this.dialogVisible = true;
				this.flieList = [{
					name: "",
					url: a.companyLogo
				}];
				this.projectList();
				this.ruleForm.companyName = a.companyName;
				this.ruleForm.companyContext = a.companyContext;
				this.ruleForm.companyLogo = a.companyLogo;
				this.id = a.id;
				this.ruleForm.subjectId = [];
				let params = {
					id: this.id,
				};
				api.findById(params).then((res) => {
					if (res.code == 0) {
						console.log(res, 23333);
						res.data.list.forEach((item) => {
							this.ruleForm.subjectId.push(item.projectId);
							this.ruleForm.subjectId = [...new Set(this.ruleForm.subjectId)];
						});
						console.log(this.ruleForm.subjectId, 456456);
					}
				});
			},

			//分页
			classCompanySizeChange(val) {
				this.totalObj.pageSize = val;
				this.classCompanyInit();
			},
			classCompanyCurrentChange(val) {
				this.totalObj.currentPage = val;
				this.classCompanyInit();
			},
			//路由传值公司ID
			employeeInformationTable(val) {
				let id = val.id;
				this.$router.push({
					path: "/newRealTask/components/marketingProjectEditor",
					query: {
						id: id,
						subjectId: this.ruleForm.subjectId
					},
				});
			},
		},
	};
</script>

<style lang="scss">
	.classCompany {
		cursor: default;
		width: 1062px;
		height: 100%;

		//   & > div {
		//   height: 100%;
		// }
		.classCompanyTitle {
			cursor: pointer;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 15px;
			background: white;

			p {
				color: #004e96;
				font-weight: 600;
				font-size: 20px;
				cursor: default;
			}
		}

		.classCompanyContent {
			height: 100%;

			.cardAll {
				max-height: calc(100% - 130px);
				overflow-y: auto;
				min-height: calc(100% - 130px);

				span,
				i {
					cursor: pointer;
				}

				.box-card {
					padding: 20px;
					display: flex;
					background: #ffffff;
					border: #e6e6e6 solid 1px;
					border-radius: 8px;
					height: 120px;
					margin: 1.4%;

					&:hover {
						box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
					}
				}

				.rsgl {
					background: linear-gradient(360deg,
							#5a9ffc 0%,
							#5da1fb 38%,
							#aed1e8 100%,
							#aed1e8 100%);
					opacity: 0.4;
					display: inline-block;
					position: absolute;
					width: 48px;
					height: 5px;
					left: 0px;
					top: 11px;
					z-index: 1;
				}

				.gsywgl {
					background: linear-gradient(360deg,
							#5a9ffc 0%,
							#5da1fb 38%,
							#aed1e8 100%,
							#aed1e8 100%);
					opacity: 0.4;
					display: inline-block;
					position: absolute;
					width: 72px;
					height: 5px;
					left: 0px;
					top: 11px;
				}

				.del {
					background: linear-gradient(360deg,
							#5a9ffc 0%,
							#5da1fb 38%,
							#aed1e8 100%,
							#aed1e8 100%);
					opacity: 0.4;
					display: inline-block;
					position: absolute;
					width: 72px;
					height: 5px;
					left: 0px;
					top: 11px;
				}

				.jrbgq {
					background: linear-gradient(360deg,
							#5a9ffc 0%,
							#5da1fb 38%,
							#aed1e8 100%,
							#aed1e8 100%);
					opacity: 0.4;
					display: inline-block;
					position: absolute;
					width: 59px;
					height: 5px;
					left: 0px;
					top: 11px;
				}
			}
		}

		.selectePages {
			height: 50px;
			width: 100%;
			text-align: right;
			margin-top: 20px;
		}

		.el-dialog {
			border-radius: 25px;
			font-weight: 600;
		}

		.el-input,
		.el-textarea {
			width: 290px;
		}

		.el-form-item__content {
			margin-left: 0px !important;
		}

		.upload_custom {

			.el-upload--picture-card,
			.el-upload-list__item {
				width: 80px;
				height: 80px;
			}

			.el-input__icon {
				line-height: 80px;
			}

			.el-upload {
				line-height: 80px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/newRealTask/components/classCompany.vue